// extracted by mini-css-extract-plugin
export default {"nextProject":"styles_nextProject__sGg1E"};